import { render } from "./Cert_check.vue?vue&type=template&id=5ecd088a&scoped=true"
import script from "./Cert_check.vue?vue&type=script&lang=js"
export * from "./Cert_check.vue?vue&type=script&lang=js"

import "./Cert_check.vue?vue&type=style&index=0&id=5ecd088a&lang=less&scoped=true"
import "./Cert_check.vue?vue&type=style&index=1&id=5ecd088a&lang=css"

import exportComponent from "D:\\project\\web\\clue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecd088a"]])

export default __exports__